import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import classNames from 'classnames'

const styleSheet = {
    container: {
        position: 'relative',
        overflow: 'hidden',
        width: ({ width }) => width,
        height: ({ height }) => height,
    },

    iframe: {
        position: 'absolute',
        top: ({ top }) => top,
        left: ({ left }) => left,
        height: ({ iframeHeight }) => iframeHeight,
        width: ({ iframeWidth }) => iframeWidth,
        pointerEvents: 'none',
    },

    countIconStyle: {
        background: '#000000',
        position: 'absolute',
        bottom: '5%',
        right: '5%',
        opacity: 0.6,
        borderRadius: '16px',
        padding: '4px',
        width: '48px',
        height: '20px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        color: 'white',
        transition: '0.5s ease-in-out',
    },

    countValueStyle: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
    },

    imgStyle: {
        width: '16px',
        height: '12px',
    },

    countStyle: {
        position: 'absolute',
        bottom: '5%',
        right: '5%',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        background: '#000000',
        color: 'white',
        opacity: 0.6,
        borderRadius: '16px',
        padding: '4px',
        width: '34px',
        height: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: '0.5s ease-in-out',
    },
}

const InstagramThumbnail = ({ className, classes, embedId, onClick, hover, count, img }) => (
    <div className={classNames(classes.container, className)} onClick={onClick}>
        <iframe
            className={classes.iframe}
            src={`https://www.instagram.com/p/${embedId}/embed`}
            frameBorder="0"
            allowFullScreen=""
            scrolling="no"
        ></iframe>
        {count &&
            (hover ? (
                <span className={classes.countIconStyle}>
                    <span className={classes.countValueStyle}>{count}</span>
                    <span>
                        <img src={img} className={classes.imgStyle} />
                    </span>
                </span>
            ) : (
                <span className={classes.countStyle}>+{count}</span>
            ))}
    </div>
)

InstagramThumbnail.defaultProps = {
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    iframeHeight: '100%',
    iframeWidth: '100%',
}

export default compose(injectSheet(styleSheet))(InstagramThumbnail)
